import {
  Elements,
  PaymentMethodMessagingElement,
} from "@stripe/react-stripe-js";

import { stripeLoader, useStripePublishableKey } from "modules/stripe";
import { currencyService } from "toolbox/CurrencyService";
import { formatCurrency } from "toolbox/Money";

type PricingPreviewProps = {
  defaultPrice: number;
  memberPrice?: number;
  isPriceSet: boolean;
  packageUnitType: string | null | undefined;
  affirmEnabled?: boolean;
  type?: "Treatment" | "Package" | "Product" | "ProductFromExternalSource";
  isMember?: boolean;
};

export const PricingPreview = ({
  defaultPrice,
  memberPrice,
  isPriceSet,
  packageUnitType,
  affirmEnabled = false,
  type = "Treatment",
  isMember = false,
}: PricingPreviewProps) => {
  const stripeKey = useStripePublishableKey();

  const stripePromise = stripeLoader.getStripe(stripeKey);
  const currency = currencyService.getCurrency();

  const defaultPricing = (
    <div className="text-body1">
      {isPriceSet || type == "Package" ? "" : "From "}
      <span className="text-bold1">{formatCurrency(defaultPrice)}</span>
      {!isPriceSet || type == "Package" ? "" : `/${packageUnitType}`}
    </div>
  );

  const memberPricing = (
    <div className="text-body1">
      <span>{isPriceSet || type == "Package" ? "" : "From "}</span>
      <span className="pr-[6px]">
        {formatCurrency(defaultPrice)}
        {!isPriceSet || type == "Package" ? "" : `/${packageUnitType}`}
      </span>
      <span className="border-l border-black pl-[6px] text-bold1 text-primary">
        {memberPrice ? formatCurrency(memberPrice) : ""} member
      </span>
    </div>
  );

  const stripeElementAppearance = {
    variables: {
      fontSizeBase: "15px",
      colorText: "#6B7070",
    },
    rules: {
      ".PaymentMethodMessaging": {
        textAlign: "center",
      },
    },
  };

  return (
    <div data-testid="pricing-preview">
      <div className="flex flex-col items-center pb-2">
        {memberPrice ? memberPricing : defaultPricing}
      </div>
      {affirmEnabled && (
        <Elements
          stripe={stripePromise}
          options={{ appearance: stripeElementAppearance }}
        >
          <PaymentMethodMessagingElement
            options={{
              amount: isMember ? memberPrice ?? defaultPrice : defaultPrice,
              currency: currency.code as "USD" | "CAD",
              paymentMethodTypes: ["affirm"],
              countryCode: currency.code == "CAD" ? "CA" : "US",
            }}
          />
        </Elements>
      )}
    </div>
  );
};
